import {
  CREATE_NEWS_GENERATION_RECORD,
  CREATE_NEWS_GENERATION_RECORD_SUCCESS,
  CREATE_NEWS_GENERATION_RECORD_FAILURE,
  UPDATE_NEWS_GENERATION_RECORD,
  UPDATE_NEWS_GENERATION_RECORD_SUCCESS,
  UPDATE_NEWS_GENERATION_RECORD_FAILURE,
  DELETE_NEWS_GENERATION_RECORD,
  DELETE_NEWS_GENERATION_RECORD_SUCCESS,
  DELETE_NEWS_GENERATION_RECORD_FAILURE,
  GET_NEWS_GENERATION_RECORD,
  GET_NEWS_GENERATION_RECORD_SUCCESS,
  GET_NEWS_GENERATION_RECORD_FAILURE,
  LIST_NEWS_GENERATION_RECORDS,
  LIST_NEWS_GENERATION_RECORDS_SUCCESS,
  LIST_NEWS_GENERATION_RECORDS_FAILURE,
} from "../actions/newsGenerationActions";

const initialState = {
  // News generation records
  newsGenerationRecords: [],
  newsGenerationRecordsConnection: null,
  currentNewsGenerationRecord: null,

  // Loading states
  newsGenerationLoading: false,
  createNewsGenerationLoading: false,
  updateNewsGenerationLoading: false,
  deleteNewsGenerationLoading: false,
  getNewsGenerationLoading: false,
  listNewsGenerationLoading: false,

  // Error states
  newsGenerationError: null,
  createNewsGenerationError: null,
  updateNewsGenerationError: null,
  deleteNewsGenerationError: null,
  getNewsGenerationError: null,
  listNewsGenerationError: null,

  // Success states
  createNewsGenerationSuccess: false,
  updateNewsGenerationSuccess: false,
  deleteNewsGenerationSuccess: false,
  getNewsGenerationSuccess: false,
  listNewsGenerationSuccess: false,
};

const newsGenerationReducer = (state = initialState, action) => {
  switch (action.type) {
    // Create news generation record
    case CREATE_NEWS_GENERATION_RECORD:
      return {
        ...state,
        createNewsGenerationLoading: true,
        createNewsGenerationError: null,
        createNewsGenerationSuccess: false,
      };
    case CREATE_NEWS_GENERATION_RECORD_SUCCESS:
      return {
        ...state,
        createNewsGenerationLoading: false,
        createNewsGenerationSuccess: true,
        newsGenerationRecords: [...state.newsGenerationRecords, action.payload],
      };
    case CREATE_NEWS_GENERATION_RECORD_FAILURE:
      return {
        ...state,
        createNewsGenerationLoading: false,
        createNewsGenerationError: action.error,
        createNewsGenerationSuccess: false,
      };

    // Update news generation record
    case UPDATE_NEWS_GENERATION_RECORD:
      return {
        ...state,
        updateNewsGenerationLoading: true,
        updateNewsGenerationError: null,
        updateNewsGenerationSuccess: false,
      };
    case UPDATE_NEWS_GENERATION_RECORD_SUCCESS:
      return {
        ...state,
        updateNewsGenerationLoading: false,
        updateNewsGenerationSuccess: true,
        newsGenerationRecords: state.newsGenerationRecords.map((record) =>
          record.id === action.payload.id ? action.payload : record
        ),
        currentNewsGenerationRecord: action.payload,
      };
    case UPDATE_NEWS_GENERATION_RECORD_FAILURE:
      return {
        ...state,
        updateNewsGenerationLoading: false,
        updateNewsGenerationError: action.error,
        updateNewsGenerationSuccess: false,
      };

    // Delete news generation record
    case DELETE_NEWS_GENERATION_RECORD:
      return {
        ...state,
        deleteNewsGenerationLoading: true,
        deleteNewsGenerationError: null,
        deleteNewsGenerationSuccess: false,
      };
    case DELETE_NEWS_GENERATION_RECORD_SUCCESS:
      return {
        ...state,
        deleteNewsGenerationLoading: false,
        deleteNewsGenerationSuccess: true,
        newsGenerationRecords: state.newsGenerationRecords.filter(
          (record) => record.id !== action.payload.id
        ),
        currentNewsGenerationRecord: null,
      };
    case DELETE_NEWS_GENERATION_RECORD_FAILURE:
      return {
        ...state,
        deleteNewsGenerationLoading: false,
        deleteNewsGenerationError: action.error,
        deleteNewsGenerationSuccess: false,
      };

    // Get news generation record
    case GET_NEWS_GENERATION_RECORD:
      return {
        ...state,
        getNewsGenerationLoading: true,
        getNewsGenerationError: null,
        getNewsGenerationSuccess: false,
      };
    case GET_NEWS_GENERATION_RECORD_SUCCESS:
      return {
        ...state,
        getNewsGenerationLoading: false,
        getNewsGenerationSuccess: true,
        currentNewsGenerationRecord: action.payload,
      };
    case GET_NEWS_GENERATION_RECORD_FAILURE:
      return {
        ...state,
        getNewsGenerationLoading: false,
        getNewsGenerationError: action.error,
        getNewsGenerationSuccess: false,
      };

    // List news generation records
    case LIST_NEWS_GENERATION_RECORDS:
      return {
        ...state,
        listNewsGenerationLoading: true,
        listNewsGenerationError: null,
        listNewsGenerationSuccess: false,
      };
    case LIST_NEWS_GENERATION_RECORDS_SUCCESS:
      return {
        ...state,
        listNewsGenerationLoading: false,
        listNewsGenerationSuccess: true,
        newsGenerationRecordsConnection: action.payload,
        newsGenerationRecords: action.payload.items || [],
      };
    case LIST_NEWS_GENERATION_RECORDS_FAILURE:
      return {
        ...state,
        listNewsGenerationLoading: false,
        listNewsGenerationError: action.error,
        listNewsGenerationSuccess: false,
      };

    default:
      return state;
  }
};

export default newsGenerationReducer;
